import { useState } from 'react';
import API_service from "../../xAppLib/providers/API_service";
import { supportsPDFs } from "../../xAppLib/helpers/pdf";
import { Button, Modal } from "semantic-ui-react";
import ShareDownloadButton from "../../xAppLib/UIelems/ShareDownloadButton";
import { fetchAsBlobUrl } from "../../helpers/api_file";

export function viewScriptUrl(sid) {
	return `${API_service.API_BASE_URL}viewScript?s=${sid}`;
}

export function PreviewDocument(props) {
	const {
		url,
		children,
		doc_name = 'Document',
		onClosed,
		onOpenChange,
		trigger,
		print: showPrint = true,
		viewOnly = false,
		...rest
	} = props

	const [show, setShow] = useState(false);
	const [blobUrl, setBlobUrl] = useState(null);
	const [printBlobUrl, setPrintBlobUrl] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const openModal = async () => {
		setShow(true);
		onOpenChange?.(true);
		setLoading(true);
		setError(null);
		try {
			const [main, print] = await Promise.all([
				fetchAsBlobUrl(url),
				showPrint && !viewOnly ? fetchAsBlobUrl(`${url}${url.includes('?') ? '&' : '?'}view=print`) : Promise.resolve(null),
			]);
			setBlobUrl(main);
			setPrintBlobUrl(print);
		} catch (e) {
			setError(e.message);
		} finally {
			setLoading(false);
		}
	};

	const onClose = () => {
		setShow(false);
		onOpenChange?.(false);
		blobUrl?.startsWith('blob:') && URL.revokeObjectURL(blobUrl);
		printBlobUrl?.startsWith('blob:') && URL.revokeObjectURL(printBlobUrl);
		setBlobUrl(null);
		setPrintBlobUrl(null);
		onClosed?.();
	};

	const view_url = blobUrl && (!supportsPDFs() ? `/pdf-view/viewer.html?file=` + encodeURIComponent(blobUrl) : blobUrl);

	return (<>
		{!trigger && <a href="#" className='ui blue button' target='_blank' data-testid='link-download' {...rest} onClick={e => {
			e.preventDefault();
			openModal();
		}}>
			{children || `Download ${doc_name}`}
		</a>}
		<Modal open={show} onOpen={trigger ? openModal : undefined} onClose={onClose} closeIcon trigger={trigger}>
			<Modal.Header style={{display: 'flex'}}>
				<div>{doc_name}</div>
				{(!viewOnly || !supportsPDFs()) && blobUrl && (
					<Button size='small'
						as='a'
						style={{marginLeft: 'auto'}}
						href={blobUrl}
						icon="external alternate"
						target='_blank'/>
				)}
			</Modal.Header>
			<Modal.Content>
				{loading && <div style={{padding: '2em', textAlign: 'center'}}>Loading...</div>}
				{error && <div style={{padding: '2em', textAlign: 'center', color: 'red'}}>{error}</div>}
				{view_url && <iframe src={view_url} style={{width: '100%', height: '70vh'}} frameBorder="0"></iframe>}
			</Modal.Content>
			<Modal.Actions>
				{!viewOnly && blobUrl && (
					<ShareDownloadButton url={blobUrl} filename={`InstantScripts ${doc_name}.pdf`}/>
				)}
				{showPrint && !viewOnly && printBlobUrl && (
					<ShareDownloadButton url={printBlobUrl} label={'Print friendly'}
										 filename={`InstantScripts ${doc_name} (print).pdf`}
					/>
				)}
			</Modal.Actions>
		</Modal>
	</>);
}
